import * as React from "react";
import { Link } from "react-router-dom";
import { toggleLogin } from "../../utils/toggleLogin";
import { LoginContext } from "../../context/loginContext";
import { Button } from "@chakra-ui/react";

import { Amplify, Auth } from "aws-amplify";
import { AwsConfigAuth } from "../config/auth";

import styled from "@emotion/styled";
import { css } from "@emotion/css";

Amplify.configure({ Auth: AwsConfigAuth });

const StyledAccount = styled.div``;

export const Account = () => {
  const { isLoggedIn, loading, setLoading, setIsLoggedIn } = React.useContext(
    LoginContext
  );

  const onLogout = async () => {
    if (setLoading) setLoading(true);
    try {
      //await toggleLogin();
      await Auth.signOut();
      if (setIsLoggedIn) setIsLoggedIn(false);
    } catch (err) {
      if (setLoading) setLoading(false);
    }
    if (setLoading) setLoading(false);
  };

  return (
    <StyledAccount>
      {!isLoggedIn ? (
        <Link to="/login">
          <Button
            variant="link"
            _hover={{ textDecoration: 'none' }}
            fontWeight='normal'
            // size="sm"
            className={css`
              color: white;
              width: 75px !important;
            `}
          >
            Login
          </Button>
        </Link>
      ) : (
        <Button
          isLoading={loading}
          onClick={() => onLogout()}
          // size="sm"
          variant="link"
          fontWeight='normal'
          _hover={{ textDecoration: 'none' }}
          isDisabled={loading}
          className={css`
            width: 75px !important;
          `}
        >
          Logout
        </Button>
      )}
    </StyledAccount>
  );
};
